/** Creators working with an agency, as the public pages get them (`workingCreators` in server/join.ts). */
export interface WorkingCreators {
  /** Every creator working with the agency. */
  total: number;
  /** A shuffled pool of up to 20 with a real profile photo; name is a first name and last initial. */
  avatars: { name: string; image: string | null }[];
}

/**
 * Below this many creators the pages show faces only, no numbers ("+3", "8 creators work with…"):
 * small numbers undersell. From here on the count is shown too.
 */
export const SHOW_CREATOR_COUNT_FROM = 500;

/** Whether the creator count is big enough to show. */
export const showCreatorCount = (creators: WorkingCreators | null | undefined) =>
  (creators?.total ?? 0) >= SHOW_CREATOR_COUNT_FROM;

/** True when there are photos to show (the pages show something else otherwise). */
export const hasPhotos = (creators: WorkingCreators | null | undefined) => Boolean(creators?.avatars.some((c) => c.image));
